import { CTASection } from '@components/pages/agent-application/create/styled';
import ImageComponent from '@components/utils/image';
import React from 'react';

import formsuccess from '../../../../../assets/images/formsuccess.jpg';
import { TypeButton } from '../../../../utils/button';
import { statusMessageObject } from './helpers';
import { StatusHeaderSection, StatusSection } from './styled';

const StatusComponent = ({
	status,
	onExit,
	onStatusAction,
}: {
	status: boolean;
	onExit: () => void;
	onStatusAction: () => void;
}) => {
	const statusMessage = statusMessageObject[status ? 'success' : 'failed'];
	return (
		<StatusSection>
			<StatusHeaderSection>
				<h3>{statusMessage.title}</h3>
				<p>{statusMessage.description}</p>
			</StatusHeaderSection>

			<ImageComponent src={statusMessage.src} />

			<CTASection>
				<TypeButton
					title={status ? 'Print Application' : 'Retry'}
					onClick={onStatusAction}
				/>
				{status && (
					<TypeButton
						title='Exit Form'
						className='prevbtn'
						onClick={onExit}
					/>
				)}
			</CTASection>
		</StatusSection>
	);
};

export default StatusComponent;
